import React from 'react';
import { ArrowRight } from 'lucide-react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import ErrorPage from '../../Common/ErrorPages';

const CLSFINotFound = () => (
  <ErrorPage
    Header={Header}
    Footer={Footer}
    brandAttr="CLS"
    code="404"
    title="Sivua ei löytynyt"
    description="Etsimääsi sivua ei ole olemassa tai se on siirretty."
    primaryCta={{ label: 'Etusivulle', to: '/clothing/cls-fi', icon: <ArrowRight size={20} /> }}
    secondaryCta={{ label: 'Siirry FAQ-sivulle', to: '/clothing/cls-fi/faq' }}
  />
);

export default CLSFINotFound;
